/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 18:31:31 GMT
 */

export const ColorBasePrimary = "#61dafb";
export const ColorBaseSecondary = "#fc7aa5";
export const ColorText = "#666666";
export const ColorBackground = "#eeeeee";
export const ColorWithOpacity = "#006699";
export const ColorDefault = "#61dafb";
export const FontSomecolor = "#666666";
export const FontFullStyle = {"color":"#61dafb","fontSize":"18px","margin":10,"fontFamily":"Poppins-Regular"};
export const FontSize1125 = "1.125rem";
